if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.touchStartX = null;
        this.setupNav();
      }

      setupNav() {
        const prevBtn = this.querySelector('.product-media-modal__nav--prev');
        const nextBtn = this.querySelector('.product-media-modal__nav--next');

        // stopPropagation su pointerup: la classe ModalDialog (da cui eredita questo
        // elemento) chiude il modal su QUALSIASI pointerup col mouse che non sia dentro
        // deferred-media/product-model. Senza questo, cliccare i bottoni chiude il modal.
        [prevBtn, nextBtn].forEach((btn) => {
          if (!btn) return;
          btn.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        if (prevBtn) prevBtn.addEventListener('click', () => this.showPrevious());
        if (nextBtn) nextBtn.addEventListener('click', () => this.showNext());

        // Frecce tastiera
        this.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowLeft') this.showPrevious();
          if (event.code === 'ArrowRight') this.showNext();
        });

        // Swipe touch (mobile) - pointerType 'touch' non attiva la chiusura del modal,
        // quindi qui non serve stopPropagation
        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          content.addEventListener(
            'touchstart',
            (event) => {
              this.touchStartX = event.touches[0].clientX;
            },
            { passive: true }
          );
          content.addEventListener(
            'touchend',
            (event) => {
              if (this.touchStartX === null) return;
              const deltaX = event.changedTouches[0].clientX - this.touchStartX;
              const threshold = 50;
              if (deltaX > threshold) this.showPrevious();
              else if (deltaX < -threshold) this.showNext();
              this.touchStartX = null;
            },
            { passive: true }
          );
        }
      }

      show(opener) {
        super.show(opener);
        const scrollY = window.scrollY;
        document.body.dataset.scrollY = scrollY;
        document.body.style.overflow = 'hidden';
        this.showActiveMedia();
      }

      hide() {
        super.hide();
        document.body.style.overflow = '';
        const scrollY = document.body.dataset.scrollY;
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY));
          delete document.body.dataset.scrollY;
        }
      }

      getMediaItems() {
        return [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
      }

      navigate(direction) {
        const items = this.getMediaItems();
        if (items.length < 2) return;
        const currentIndex = items.findIndex((el) => el.classList.contains('active'));
        if (currentIndex === -1) return;
        const nextIndex = (currentIndex + direction + items.length) % items.length;
        this.activateMedia(items[nextIndex]);
      }

      showNext() {
        this.navigate(1);
      }

      showPrevious() {
        this.navigate(-1);
      }

      activateMedia(mediaElement) {
        this.querySelectorAll('[data-media-id].active').forEach((element) => {
          element.classList.remove('active');
        });

        const template = mediaElement.querySelector ? mediaElement.querySelector('template') : null;
        const content = template ? template.content : null;
        mediaElement.classList.add('active');

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = 0;
          container.scrollTop = 0;
        }

        if (
          mediaElement.nodeName == 'DEFERRED-MEDIA' &&
          content &&
          content.querySelector('.js-youtube')
        )
          mediaElement.loadContent();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = 0;
          container.scrollTop = 0;
        }

        activeMedia.scrollIntoView({ block: 'nearest', inline: 'start' });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}